// libs
import { motion, Variants } from "framer-motion";
import styled from "styled-components";
// components
import { Box } from "../Box";
import { Text } from "../Text";
import ATInnerSlides from "./ATInnerSlides";
import { FlexContainer, FlexItem } from "../Flex";
// other
import { InteractiveSlide } from "../../models/client";

interface ATSlideProps {
  slide: InteractiveSlide;
  direction: number;
  innerIndex: number;
  visualInnerSlides: any;
}

const variants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? 50 : -50,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 50 : -50,
      opacity: 0,
    };
  },
};

const FlexInnerSlides = styled(FlexItem)`
  position: relative;
  z-index: 0;
`;

const FlexCopy = styled(FlexItem)``;

const MotionSlidesBox = styled(motion(Box))`
  position: relative;
  height: 100%;
`;

const variantsInnerSlides: Variants = {
  hidden: { y: -100, opacity: 0 },
  inView: { y: 100, opacity: 1 },
};

function ATSlide({
  slide,
  direction,
  innerIndex,
  visualInnerSlides,
}: ATSlideProps) {
  return (
    <motion.div
      custom={direction}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        duration: 1,
      }}
    >
      <FlexContainer
        flexWrap="wrap"
        justifyContent="space-between"
        alignItems="center"
      >
        <FlexInnerSlides
          position="relative"
          flex={["0 0 100%", null, null, "0 0 55%"]}
          order={[null, null, null, 1]}
        >
          {slide.innerSlides.length ? (
            <MotionSlidesBox variants={variantsInnerSlides} margin="0 auto">
              <ATInnerSlides
                direction={direction}
                innerSlides={slide.innerSlides}
                innerSlideIndex={innerIndex}
                visualInnerSlides={visualInnerSlides}
              />
            </MotionSlidesBox>
          ) : null}
        </FlexInnerSlides>
        <FlexCopy
          flex={["0 0 100%", null, null, "0 0 45%"]}
          maxWidth={[440, null, null, "45%"]}
        >
          <Box px={["0px", null, null, 4]}>
            <Box mb={3}>
              <Text variant="h2">{slide.heading}</Text>
            </Box>
            <Text>{slide.copy}</Text>
          </Box>
        </FlexCopy>
      </FlexContainer>
    </motion.div>
  );
}

export default ATSlide;
